import React from 'react';
import { ListItemIcon, ListItem, ListItemButton, ListItemText, Box, Typography, Stack, Chip, Checkbox, Divider } from '@mui/material';
import { Block, Person, FilterList, SellOutlined } from '@mui/icons-material';
import ThemedChip from '../themedChip/ThemedChip';
import GroupTypeChip from './GroupTypeChip';
import { format } from 'date-fns';

//todo tooltip for long topic, need to use forwardRef on the Topic component

const NavigationItem = ({ item, type, selected, onSelect, onSetSelectedItem, action, onFilterByTag, showCreatedDate, contactGroupAddedDates }) => {

    const handleFilterByTag = (event, id) => {
        event.stopPropagation();
        onFilterByTag(id);
    };

    const matchedDate = contactGroupAddedDates?.find(d => d.groupId === item.id);

    const renderCreatedDate = showCreatedDate ? (
        <Typography
            variant="caption"
            sx={{
                color: 'text.secondary',
                fontWeight: 500
            }}
        >
            Added: {matchedDate?.createdDateTime
                ? format(new Date(matchedDate.createdDateTime), 'dd/MM/yyyy HH:mm')
                : '-'}
        </Typography>
    ) : null;

    const ListItemInner = () => {
        if (type === 'segment') {
            return (
                <>
                    <ListItemText
                        disableTypography
                        primary={(
                            <Typography
                                variant="body2"
                                sx={{ fontWeight: 500, display: 'flex', alignItems: 'center', gap: 1 }}
                            >
                                {item.name}
                            </Typography>
                        )}
                        secondary={(
                            <>
                                <Chip
                                    size="small"
                                    variant="outlined"
                                    sx={{ mt: 1 }}
                                    label={(
                                        <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
                                            <FilterList sx={{ fontSize: 'inherit', mr: 0.5 }} />
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                {item.filters.length} {item.filters.length === 1 ? 'Filter' : 'Filters'}
                                            </Typography>
                                        </Box>
                                    )}
                                />
                                {item.tags.length > 0 && (
                                    <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                        {item.tags.map(tag => (
                                            <ThemedChip
                                                key={tag.id}
                                                chipProps={{
                                                    size: 'small',
                                                    label: tag.name,
                                                    icon: <SellOutlined fontSize="small" />,
                                                    onClick: e => handleFilterByTag(e, tag.id)
                                                }}
                                                colour={tag.colour}
                                            />
                                        ))}
                                    </Stack>
                                )}
                            </>
                        )}
                    />
                </>
            );
        }

        return (
            <>
                {Boolean(onSelect) && (
                    <ListItemIcon>
                        <Checkbox
                            edge="start"
                            checked={selected}
                            tabIndex={-1}
                            disableRipple
                            onChange={onSelect}
                        />
                    </ListItemIcon>
                )}
                <ListItemText
                    disableTypography
                    primary={(
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {item.name}
                        </Typography>
                    )}
                    secondary={(
                        <>
                            {renderCreatedDate}
                            <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                <GroupTypeChip type={item.type} />
                                <Chip
                                    size="small"
                                    icon={<Person fontSize="small" />}
                                    label={`${item.contacts?.toLocaleString() ?? 0} Contacts`}
                                    variant="outlined"
                                />
                                <Chip
                                    size="small"
                                    icon={<Block fontSize="small" />}
                                    label={`${item.suppressed?.toLocaleString() ?? 0} Suppressed`}
                                    variant="outlined"
                                />
                            </Stack>
                            {item.tags.length > 0 && (
                                <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                    {item.tags.map(tag => (
                                        <ThemedChip
                                            key={tag.id}
                                            chipProps={{
                                                size: 'small',
                                                label: tag.name,
                                                icon: <SellOutlined fontSize="small" />,
                                                onClick: e => handleFilterByTag(e, tag.id)
                                            }}
                                            colour={tag.colour}
                                        />
                                    ))}
                                </Stack>
                            )}
                        </>
                    )}
                />
            </>
        );
    };

    // todo improve this, there is a subtly different amount of padding between a clickable and non-clickable navigation items
    // this is because you lied when you were 17

    return (
        <>
            <Divider />
            <ListItem
                disablePadding={Boolean(onSetSelectedItem)}
                secondaryAction={action}
            >
                {onSetSelectedItem ? (
                    <ListItemButton
                        dense
                        selected={selected}
                        onClick={() => onSetSelectedItem(item)}
                    >
                        <ListItemInner />
                    </ListItemButton>
                ) : (
                    <ListItemInner />
                )}
            </ListItem>
        </>
    );
};

export default NavigationItem;